import {
  DeleteOrganizationUsersMutation,
  OrganizationUsersListQuery,
  type OrganizationUsersListRow,
} from "@/admin/entities/organizationUsers";
import { InnerCRUD } from "@/shared/components";
import type { OrganizationShowQueryType } from "@/types/graphql/admin.generated";
import {
  createOrganizationUserInitialVariables,
  createOrganizationUserSchema,
  getOrganizationUsersColumnsConfig,
  getOrganizationUsersTextsConfig,
  mapOrganizationUsersColumns,
} from "../../model";

interface OrganizationUsersProps {
  id?: string;
  organization?: OrganizationShowQueryType;
}
export const OrganizationUsers: React.FC<OrganizationUsersProps> = ({ id }) => {
  return (
    <InnerCRUD<OrganizationUsersListRow>
      listQuery={OrganizationUsersListQuery}
      listQueryVariables={{ filter: { organizationId: id } }}
      getTableData={(data) => data?.organizationUsers}
      mapColumns={mapOrganizationUsersColumns}
      columns={getOrganizationUsersColumnsConfig()}
      createSchema={createOrganizationUserSchema}
      createMutationVariables={() => ({
        input: {
          organizationId: id,
        },
      })}
      createInitialVariables={createOrganizationUserInitialVariables}
      deleteMutation={DeleteOrganizationUsersMutation}
      texts={getOrganizationUsersTextsConfig()}
    />
  );
};
